import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  toaDisclaimer: () => i18n.t(i18nKeys.signupForm__legalAgreementDE),
  emailAddress: () => i18n.t(i18nKeys.signupForm__emailAddressText),
  getStarted: () => i18n.t(i18nKeys.dropshippingStatus__startDashingGetStarted),
  next: () => i18n.t(i18nKeys.common__next),
  alreadyStartedSigningUp: () => i18n.t(i18nKeys.signupForm__alreadySignedUp),
  back: () => i18n.t(i18nKeys.common__back),
  continue: () => i18n.t(i18nKeys.common__continue),
  phoneNumber: () => i18n.t(i18nKeys.common__phone),
  countryLabel: () => i18n.t(i18nKeys.common__country),
  countryCode: () => i18n.t(i18nKeys.signupForm__countryCodeText),
  zipCode: () => i18n.t(i18nKeys.mailingAddress__address__zipCode),
  genericError: () => i18n.t(i18nKeys.errorBoundary__title),
}
